export const rawCommonPdfStyles = {
  page: {
    flexDirection: 'column' as const,
    backgroundColor: '#ffffff',
  },
  section: {
    padding: 5,
  },
};
